import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignUpMutationVariables = Types.Exact<{
  phone: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
  referrer?: Types.InputMaybe<Types.Scalars['String']['input']>;
  lang: Types.Scalars['String']['input'];
  promoCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SignUpMutationPage = { readonly __typename?: 'RootMutationType', readonly signUpWithCompany: { readonly __typename?: 'AccountsAuthToken', readonly token: string, readonly user: { readonly __typename?: 'AccountsUser', readonly id: string, readonly uuid: string, readonly phone?: string | null, readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly insertedAt: string, readonly firstCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string } | null } } };


export const SignUpDocument = gql`
    mutation SignUp($phone: String!, $password: String!, $email: String, $referrer: String, $lang: String!, $promoCode: String) {
  signUpWithCompany(
    phone: $phone
    password: $password
    email: $email
    referrer: $referrer
    lang: $lang
    promoCode: $promoCode
  ) {
    token
    user {
      id
      uuid
      phone
      roles
      insertedAt
      firstCompany {
        id
        uuid
        name
      }
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutationPage, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      email: // value for 'email'
 *      referrer: // value for 'referrer'
 *      lang: // value for 'lang'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutationPage, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutationPage, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutationPage>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutationPage, SignUpMutationVariables>;